import MotionDurations from '~tokens/motion-durations/MotionDurations';

enum ModalDurations {
	In = MotionDurations.Normal,
	Out = MotionDurations.Normal * 2,
}

export default ModalDurations;
